import type { StyleSystemProps } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

const content: StyleSystemProps = {
  paddingX: 6,
  width: '100%',
};

const root: StyleSystemProps = {
  width: '100%',
};
const iconCard: StyleSystemProps = {
  width: '100%',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'mono1',
  borderRadius: pxToRem(12),
  aspectRatio: '1/1',
  maxHeight: pxToRem(200),
};
const eventName: (isExpanded?: boolean) => StyleSystemProps = (isExpanded?: boolean) => ({ fontWeight: 400, textAlign: 'center', marginBottom: isExpanded ? 6 : undefined });
const collapsibleContent: StyleSystemProps = {
  transition: 'max-height 300ms ease-in-out',
  flexDirection: { _: 'column-reverse', md: 'row' },
  gap: { md: 9, _: 5 },
  overflow: 'hidden',
};

export const styles = {
  root,
  eventName,
  content,
  collapsibleContent,
  iconCard,
};
